export default __webpack_public_path__ + "static/media/pink-checkmark.030fd0ae.svg";